import { isObject, type MaterialFormInfoListItem, useApiMaterialsV1MaterialFormsRetrieve } from 'api';
import { capitalizeString } from 'ui';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

export const MaterialFormAutocomplete = (props: Omit<AutocompleteFieldProps<MaterialFormInfoListItem>, 'options'>) => {
  const { data, isLoading } = useApiMaterialsV1MaterialFormsRetrieve();

  return (
    <AutocompleteField<MaterialFormInfoListItem>
      getOptionLabel={(item) => {
        if (isObject(item) && item?.type) {
          return capitalizeString(item.type);
        }
        return '';
      }}
      loading={isLoading}
      valueField="id"
      data-testid="material-form-autocomplete"
      filterOptions={(options, state) =>
        options.filter((option) => option.type.toLowerCase().includes(state.inputValue.toLowerCase()))
      }
      options={data?.results ?? []}
      {...props}
    />
  );
};
